import { Injectable } from '@angular/core';

import { UserStoreSelectors } from '@core-lib/store/user-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserInfoResolver  {
	constructor(private store: Store) {}

	resolve(): Observable<any> | Promise<boolean> | any {
		return this.store.pipe(
			select(UserStoreSelectors.selectUserInfoFullyLoaded),
			filter(x => x),
			first()
		);
	}
}
